import { render, staticRenderFns } from "./Ball.vue?vue&type=template&id=6c571838&scoped=true&"
import script from "./Ball.vue?vue&type=script&lang=js&"
export * from "./Ball.vue?vue&type=script&lang=js&"
import style0 from "./Ball.vue?vue&type=style&index=0&id=6c571838&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c571838",
  null
  
)

export default component.exports